// extracted by mini-css-extract-plugin
export var animationAbsolute = "_1n-q";
export var animationRelative = "_1n-p";
export var backdropBlur = "_1n-0";
export var detailLabelCell = "_1n-12";
export var detailTable = "_1n-11";
export var detailValueCell = "_1n-13";
export var docIconBox = "_1n-1d";
export var docIconBoxMd = "_1n-1f";
export var docIconBoxSm = "_1n-1e";
export var docTypeRow = "_1n-16";
export var docTypeRowInner = "_1n-17";
export var dropdownMatchDatePicker = "_1n-3";
export var evidenceCardContent = "_1n-1c";
export var fileUploadSpin = "_1n-j";
export var gorgiasOpenButton = "_1n-15 _1n-d";
export var gorgiasTicketCard = "_1n-14";
export var heroModalFooterButton = "_1n-18";
export var hiddenContainer = "_1n-o";
export var iconPrimary = "_1n-1g";
export var iconQuaternary = "_1n-1i";
export var iconTertiary = "_1n-1h";
export var integrationCard = "_1n-1";
export var integrationLogoBox = "_1n-2";
export var mainColumnSticky = "_1n-1b";
export var maxWidthContainer = "_1n-19";
export var modalContentBody = "_1n-a";
export var modalHeaderImage = "_1n-5";
export var modalImageLabel = "_1n-7";
export var modalImageOverlay = "_1n-6";
export var modalImageSubtitle = "_1n-9";
export var modalImageTitle = "_1n-8";
export var modalImageWrapper = "_1n-4";
export var modalStickyFooter = "_1n-b";
export var removeButton = "_1n-e";
export var sidebarColumn = "_1n-1a";
export var spinner = "_1n-i";
export var timelineLine = "_1n-y";
export var timelineLineBlack = "_1n-10 _1n-y";
export var timelineLineGray = "_1n-z _1n-y";
export var timelineLineHeight = "_1n-x";
export var tlDotActivate = "_1n-u";
export var tlDotActivateAnim = "_1n-t";
export var tlDotHide = "_1n-s";
export var tlDotHideAnim = "_1n-r";
export var tlLineActivate = "_1n-w";
export var tlLineActivateAnim = "_1n-v";
export var uploadHint = "_1n-n";
export var uploadIconBox = "_1n-k";
export var uploadLabel = "_1n-m";
export var uploadText = "_1n-l";
export var uploadZone = "_1n-f";
export var uploadZoneCursorDefault = "_1n-h";
export var uploadZoneCursorPointer = "_1n-g";
export var uploadedFileRow = "_1n-c";
export var viewButton = "_1n-d";